export default __webpack_public_path__ + "static/media/kaminfeuer_web-sm@2x.e687b111.jpg";